import styled from 'styled-components';
import { List } from '@bynder/design-system';

export const StyledList = styled(List)`
    padding: 0;
`;
